import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  points: null,
};

const pointsSlice = createSlice({
  name: "points",
  initialState,
  reducers: {
    setUserPoints(state, action) {
      state.points = action.payload;
    },
  },
});

export const { setUserPoints } = pointsSlice.actions;
const pointsReducer = pointsSlice.reducer;

export default pointsReducer;
